const $f9490db02e23bcba$export$608cc10b605ac297 = {
    divider: '|=',
    level1: '|',
    level2: '-',
    level3: ':'
};
function $f9490db02e23bcba$export$c1fd99cfc0747069(fieldsMenu) {
    const menuList = $f9490db02e23bcba$var$getMenuListFromPoints(fieldsMenu).filter(// TODO: Not sure if this null filter is needed
    (menuListItem)=>menuListItem !== null);
    return $f9490db02e23bcba$var$filterHiddenMenuListItems(fieldsMenu, menuList);
}
function $f9490db02e23bcba$var$getMenuListFromPoints(fieldsMenu) {
    const { role: role } = window;
    const roleKey = `menu${ucfirst(role)}`;
    const menuList = fieldsMenu[roleKey] ?? fieldsMenu.menu ?? [];
    // TODO: What is the meaning of this condition? When does it occur?
    if (menuList.length === 1 && fieldsMenu[menuList[0]]) return fieldsMenu[menuList[0]];
    return menuList;
}
function $f9490db02e23bcba$var$filterHiddenMenuListItems(fieldsMenu, menuList) {
    const { role: role } = window;
    // Used to hide submenus if the top level menu is hidden
    let shouldHideLowerLevelItems;
    return menuList.filter(function(menuListItem) {
        if (menuListItem === $f9490db02e23bcba$export$608cc10b605ac297.divider) return true;
        const type = menuListItem.slice(0, 1);
        const key = menuListItem.slice(1);
        const point = fieldsMenu[key];
        if (type === $f9490db02e23bcba$export$608cc10b605ac297.level1) shouldHideLowerLevelItems = false;
        const hidden = !point || shouldHideLowerLevelItems || point.test && !test || point.config === '1' && test && !config || point.config === '0' && test && config || isPlainObject(point.hidden) && checkWhere({}, point.hidden) || isArray(point.hidden) && checkWhere({}, {
            role: point.hidden
        }) || point.hidden === role || point.admin && !user.admin || point.hidden === 1;
        if (type === $f9490db02e23bcba$export$608cc10b605ac297.level1) shouldHideLowerLevelItems = hidden;
        return !hidden;
    });
}


function $324aa8ad8eb43cbf$export$630b7735451169d5(menu, fieldsMenu, menuList) {
    let submenu;
    let submenu2;
    menuList.forEach(function(menuListItem, i) {
        const isDivider = menuListItem === (0, $f9490db02e23bcba$export$608cc10b605ac297).divider;
        const isPrevDivider = menuList[i - 1] === (0, $f9490db02e23bcba$export$608cc10b605ac297).divider;
        if (isDivider && isPrevDivider) return;
        if (isDivider) {
            $('<li class="nav-item"><hr class="dropdown-divider"></li>').appendTo(menu);
            return;
        }
        const type = menuListItem.slice(0, 1);
        const nextType = menuList[i + 1] ? menuList[i + 1].slice(0, 1) : undefined;
        const key = menuListItem.slice(1);
        const point = fieldsMenu[key];
        point.object = point.object ?? key;
        if (!point?.objectSub && point?.object !== key && !point.func) point.objectSub = key;
        point.label = $324aa8ad8eb43cbf$var$getPointLabel(point, key);
        const objIdent = !point.noAjax ? [
            point.object,
            point.objectSub
        ].filter(Boolean).join('_') : undefined;
        const clickable = (fields[key] || point.object || point.func || point.jsFunc || point.link || user.admin) && !point.noClick;
        let submenuFrame;
        const item = $324aa8ad8eb43cbf$var$buildItem(key, point);
        if (type === (0, $f9490db02e23bcba$export$608cc10b605ac297).level1) {
            const li = $('<li class="nav-item" />').appendTo(menu);
            item.addClass('nav-link').attr('aria-current', 'page').attr('data-ident', objIdent).appendTo(li);
            $('<span class="link-title" />').text(point.label).appendTo(item);
            let icon = point.icon ?? getParamSettings(point, 'icon');
            addIcon(item, icon, 'list', 'fa-lg fa-fw').prependTo(item);
            if (nextType === (0, $f9490db02e23bcba$export$608cc10b605ac297).level2) {
                item.attr({
                    'data-bs-toggle': 'collapse',
                    'data-bs-target': `#${key}-collapse`
                });
                submenuFrame = $('<div class="collapse" />').attr('id', `${key}-collapse`).appendTo(li);
                submenu = $('<ul class="sub-menu flex-column gap-1" />').appendTo(submenuFrame);
                item.on(click, function(evt) {
                    if (clickable) menuClick(evt, point, key);
                    else if (point.clickFirst && !item.hasClass('collapsed')) submenuFrame.find('.sub-link:first[data-overview]').trigger(click);
                });
            } else if (clickable) item.on(click, function(evt) {
                menuClick(evt, point, key);
            });
            if (key === 'roleChanger') submenuFrame = buildRoleChanger(li);
        }
        if (type === (0, $f9490db02e23bcba$export$608cc10b605ac297).level2) {
            const li = $('<li />').appendTo(submenu);
            item.addClass('sub-link fw-normal').text(point.label).appendTo(li);
            if (objIdent) item.attr('data-ident', objIdent);
            if (clickable && !point.func) item.attr('data-overview', true);
            if (nextType === (0, $f9490db02e23bcba$export$608cc10b605ac297).level3) {
                item.attr({
                    'data-bs-toggle': 'collapse',
                    'data-bs-target': `#${key}-collapse`
                });
                submenuFrame = $('<div class="collapse" />').attr('id', `${key}-collapse`).appendTo(li);
                submenu2 = $('<ul class="sub-menu flex-column gap-1" />').appendTo(submenuFrame);
            }
            if (clickable) item.on(click, function(evt) {
                menuClick(evt, point, key);
            });
        }
        if (type === (0, $f9490db02e23bcba$export$608cc10b605ac297).level3) {
            const li = $('<li />').appendTo(submenu2);
            item.addClass('sub-link fw-normal').text(point.label).appendTo(li);
            if (objIdent) item.attr('data-ident', objIdent);
            if (clickable) item.on(click, function(evt) {
                menuClick(evt, point, key);
            });
        }
        if (point.collapse && submenuFrame) submenuFrame.addClass('show');
    });
}
function $324aa8ad8eb43cbf$var$getPointLabel(point, key) {
    const { role: role, user: user1 } = window;
    const userLanguageLabelKey = `label${ucfirst(user1.language)}`;
    if (user1?.language !== 'de' && point[userLanguageLabelKey]) return point[userLanguageLabelKey];
    const roleLabelKey = `label${ucfirst(role)}`;
    return point[roleLabelKey] ?? point.label ?? key;
}
function $324aa8ad8eb43cbf$var$buildItem(key, point) {
    // TODO: Refactor to button tag for more semantically correct HTML
    const item = $('<a href="#" class="link-light" />').attr('id', `menu${ucfirst(key)}`).on('click', (event)=>{
        event.preventDefault();
    });
    // tip + activate
    if (point.tip) item.addTooltip(point.tip);
    if (!point.activate) return item;
    item.addClass('activate-link');
    if (getLocalFlag(key)) {
        item.addClass('active active-fix');
        if (point.jsFunc && window[point.jsFunc]) window[point.jsFunc]();
    }
    return item;
}


function $e4ff4a8d0b1ccf4e$export$ce863d6672ce9033(menu) {
    const { sidebar: sidebar } = window;
    const mini = mobile === 'smartphone' ? true : getLocalFlag('sidebar-mini');
    if (mini) sidebar.toggleClass('sidebar-mini');
    $('<li class="nav-item"><hr class="dropdown-divider"></li>').appendTo(menu);
    const li = $('<li class="nav-item"></li>').appendTo(menu);
    // TODO: Refactor to button tag for more semantically correct html
    const item = $('<a href="#" class="nav-link link-light" aria-current="page"></a>').appendTo(li).on(click, function(event) {
        event.preventDefault();
        $(this).children('svg').toggleClass('fa-angle-left fa-angle-right');
        const toggledMini = toggleLocalFlag('sidebar-mini');
        const text = toggledMini ? 'Ausklappen' : 'Einklappen';
        $(this).children('.link-title').text(text);
        sidebar.toggleClass('sidebar-mini');
    });
    const iconClass = mini ? 'fa-angle-right' : 'fa-angle-left';
    $(`<i class="icon fa-regular ${iconClass} fa-fw"></i>`).appendTo(item);
    const linkText = mini ? 'Ausklappen' : 'Einklappen';
    $('<span class="link-title" />').text(linkText).appendTo(item);
    sidebar.on('mouseover', function() {
        mini && $(this).addClass('hover');
    }).on('mouseout', function() {
        $(this).removeClass('hover');
    });
    // Side menu hidden in Tablet/Mobile view
    $(window).on('load, resize', function() {
        if (getScreenWidth() < 992) sidebar.addClass('sidebar-mini').removeClass('hover');
    });
}


function $84a73a5aea3fe786$export$d4426a50b395876f(container, shouldClearMenu) {
    if (shouldClearMenu) return;
    const search = $('<div class="search" role="search"></div>').appendTo(container);
    window.buildField(search, {
        field: 'search',
        placeholder: info.placeholder.searchMenu,
        fieldIdent: 'menu_search',
        save: function(value) {
            if (!value) {
                $('nav [data-ident]').removeClass('d-none');
                return;
            }
            $('nav [data-ident]').addClass('d-none');
            $('nav [data-ident]:icontains(' + value + ')').removeClass('d-none');
        }
    });
}



function $3f1b458e9568fd6c$export$a5d94e9c5caf4273(container, shouldUpdate) {
    if (shouldUpdate) return $('#menu').empty();
    const menuCont = $('<div id="menu-cont" class="mb-auto"></div>').appendTo(container);
    new mdb.PerfectScrollbar(menuCont[0], {
        suppressScrollX: true
    });
    return $('<ul id="menu" class="nav nav-pills flex-column gap-1" data-mdb-perfect-scrollbar="true">').appendTo(menuCont);
}


function $a627723118f2de2b$export$1cf7ffb9847dddd6(container, shouldClearMenu) {
    const fieldsMenu = $.extend(true, {}, window.fieldsMenu);
    const menu = (0, $3f1b458e9568fd6c$export$a5d94e9c5caf4273)(container, shouldClearMenu);
    const menuList = (0, $f9490db02e23bcba$export$c1fd99cfc0747069)(fieldsMenu);
    (0, $324aa8ad8eb43cbf$export$630b7735451169d5)(menu, fieldsMenu, menuList);
    (0, $e4ff4a8d0b1ccf4e$export$ce863d6672ce9033)(menu);
    (0, $84a73a5aea3fe786$export$d4426a50b395876f)(container, shouldClearMenu);
    if (test && user.admin) administrateMenu(menu, menuList);
}
window.buildMenu = $a627723118f2de2b$export$1cf7ffb9847dddd6;


//# sourceMappingURL=index.8ff3019c.js.map
